import { getPublicLang } from 'academy-common-lib/utils/url';
import useEmbeddedSignup from '../useEmbeddedSignup';
import { jsx as _jsx } from "react/jsx-runtime";
const EmbeddedSignup = ({
  pagePath,
  id,
  type,
  language = getPublicLang()
}) => {
  useEmbeddedSignup(pagePath, id, type, language, '#embedded-signup');
  return /*#__PURE__*/_jsx("div", {
    id: "embedded-signup"
  });
};
export default EmbeddedSignup;